import { isWebview } from '@dvlden/is-webview'
import { FC, useLayoutEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { FINANCES_ROUTE } from '../../constants/routing.constants'
import { PaymentStatus } from '../../types/billing'

type Props = {
    status: PaymentStatus
}

export const PaymentRedirect: FC<Props> = ({ status }) => {
    const isOpenedWithWebView = isWebview(window.navigator.userAgent)

    useLayoutEffect(() => {
        if (isOpenedWithWebView) {
            window.open(
                `arhiassistantapp://payment/${status === PaymentStatus.SUCCESS ? 'success' : 'failed'}`,
                '_self',
            )
        }
    }, [])

    if (isOpenedWithWebView) {
        return null
    }

    return <Navigate to={`${FINANCES_ROUTE}?paymentStatus=${status}`} replace />
}
